import { render, staticRenderFns } from "./LegislationSettings.vue?vue&type=template&id=91df9a56&"
import script from "./LegislationSettings.vue?vue&type=script&lang=js&"
export * from "./LegislationSettings.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports